import React, { useContext } from 'react';
import qs from 'qs';

const defaultFeatureToggles = Object.freeze({});

const castStringToBool = value => {
  if (value === 'true') {
    return true;
  }

  if (value === 'false') {
    return false;
  }

  return value;
};

export const FeatureToggleContext = React.createContext(defaultFeatureToggles);

export const extractFeaturesFromLocation = ({ location }) => {
  const features = { ...defaultFeatureToggles };

  if (!location || !location.search) {
    return features;
  }

  const query = location.search.replace(/\?/, '');
  const params = qs.parse(query, { nested: true });

  if (params.features) {
    Object.keys(params.features).forEach(key => {
      features[key] = castStringToBool(params.features[key]);
    });
  }
  return features;
};

export const withFeatureToggle = Component => {
  const AugmentedComponent = props => (
    <FeatureToggleContext.Consumer>
      {toggles => <Component {...props} toggles={toggles} />}
    </FeatureToggleContext.Consumer>
  );
  AugmentedComponent.fragment = Component.fragment;
  AugmentedComponent.displayName = Component.displayName;
  return AugmentedComponent;
};

export const useFeatureToggles = () => useContext(FeatureToggleContext);
